import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { isNil } from 'lodash-es';
import { userFeatureState, UserRootState } from './user.state';
import { UserResource } from './user.model';

export const selectUserFeature = createFeatureSelector<UserRootState>(userFeatureState);

export const userSelector = createSelector(selectUserFeature, (state: UserRootState) => {
	return state?.userRoot?.user ?? null;
});

export function userByUriSelector(userUri: string): MemoizedSelector<object, UserResource> {
	return createSelector(selectUserFeature, (state: UserRootState) => {
		if (isNil(state?.userRoot?.users)) {
			return null;
		}
		return isNil(state.userRoot.users[userUri]) ? null : state.userRoot.users[userUri];
	});
}
